import { TProductShipping } from "@/redux/feature/orderManagement/productShipping/productShippingTypes";
import dayjs from "dayjs";

const isActionRequired = (productShippingData: TProductShipping): boolean => {
  if (!productShippingData) return false;

  const {
    shipping_status,
    expected_delivery_date,
    product_receipt_proof,
    purchase_invoice,
    is_creator_buying,
  } = productShippingData;

  const isPastExpectedDate = dayjs().isAfter(dayjs(expected_delivery_date));

  // Case 1: Client ships the product but didn't upload receipt proof after expected date
  if (
    shipping_status.isShipping_by_client &&
    isPastExpectedDate &&
    !product_receipt_proof?.live_url
  ) {
    return true;
  }

  // Case 2: Creator needs to buy the product but hasn't uploaded the invoice
  if (is_creator_buying && !purchase_invoice?.live_url) {
    return true;
  }
  return false;
};

export default isActionRequired;
